<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '100px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005920')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="expensesTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
            <Form-item :label="$t('key1005921')" prop="operationType">
              <Select v-model="pageParams.operationType">
                <Option v-for="item in transactionTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsDistributePackageCost_batchExport')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <template #list>
          <DropdownMenu>
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </template>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        @on-selection-change="tableChange"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <Page
      :transfer="true"
      v-if="!tableLoading"
      class="distributor-page-box"
      :total="total"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1005922')"
      paramKeyColums="ymsMerchantPropertyLogExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {amountHandel, getDataSetBatchList, isJSON, pageJump, getEnumList} from '@/utils/common';
import dropDownFilter from "@/components/common/dropDownFilter.vue";

export default {
  name: "financialJournal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      expenseTypeList: [
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005908')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005909')}
      ],
      inputValue: 1,
      expensesTime: [],
      pageParams: {
        operationType: 'null',
        createEndTime: "",
        createStartTime: "",
        businessCodes: null, // 相关单据号
        codes: null, // 交易流水号
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [],
      originalColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005910'),
          minWidth: 150,
          align: 'left',
          key: 'code'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000748'),
          minWidth: 150,
          align: 'left',
          key: 'businessCode'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005911'),
          minWidth: 100,
          align: 'left',
          key: 'operationType',
          render(h, params) {
            let text = '-';
            let operationType = params.row.operationType;
            v.transactionTypeList.map((item) => {
              if (operationType === Number(item.value)) {
                text = item.title;
              }
            })
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005912'),
          minWidth: 170,
          align: 'left',
          key: 'createdTime',
          render(h, params) {
            let createdTime = v.$uDate.dealTime(params.row.createdTime, 'fulltime');
            return h('span', createdTime);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738'),
          minWidth: 100,
          align: 'left',
          key: 'currency'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005913'),
          minWidth: 130,
          align: 'left',
          key: 'price',
          render(h, params) {
            let price = params.row.price !== null ? amountHandel(params.row.price) : '';
            return h('div', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005914'),
          minWidth: 130,
          align: 'left',
          key: 'originalDistributorBalance',
          render(h, params) {
            let originalDistributorBalance = params.row.originalDistributorBalance !== null ? amountHandel(params.row.originalDistributorBalance) : '';
            return h('div', originalDistributorBalance);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005915'),
          minWidth: 130,
          align: 'left',
          key: 'curDistributorBalance',
          render(h, params) {
            let curDistributorBalance = params.row.curDistributorBalance !== null ? amountHandel(params.row.curDistributorBalance) : '';
            return h('div', curDistributorBalance);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005916'),
          minWidth: 180,
          align: 'left',
          key: 'originalDistributorRemainQuota',
          render(h, params) {
            let originalDistributorRemainQuota = params.row.originalDistributorRemainQuota !== null ? amountHandel(params.row.originalDistributorRemainQuota) : '';
            return h('div', originalDistributorRemainQuota);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005917'),
          minWidth: 180,
          align: 'left',
          key: 'curDistributorRemainQuota',
          render(h, params) {
            let curDistributorRemainQuota = params.row.curDistributorRemainQuota !== null ? amountHandel(params.row.curDistributorRemainQuota) : '';
            return h('div', curDistributorRemainQuota);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remark',
          width: 250,
          align: 'center',
          render(h, params) {
            let remark = params.row.remark;
            let text = v.getExpenseDetailsRemarks(remark);
            let length = isJSON(remark) ? 4 : 2;
            return v.checkContentOverflow(h, text, 250, length);
          }
        },
      ],
      tableData: [],
      selectTableData: [],
      exportType: null,
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005910'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005918'), parameterKey: 'codes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000748'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005919'), parameterKey: 'businessCodes'},
      ],
      defaultSelectValue: 1,
      creditLimitConfiguration: false,
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    },
    customFieldExportList() {
      let baseCheckBoxList = [
        {paramKey: 'code', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005910')},
        {paramKey: 'businessCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000748')},
        {paramKey: 'operationTypeCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005911')},
        {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005912')},
        {paramKey: 'currency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738')},
        {paramKey: 'price', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005913')},
        {paramKey: 'originalDistributorBalance', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005914')},
        {paramKey: 'curDistributorBalance', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005915')},
        {paramKey: 'remark', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')}
      ];
      if (this.creditLimitConfiguration) {
        baseCheckBoxList.push(
          {paramKey: 'originalDistributorRemainQuota', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005916')},
          {paramKey: 'curDistributorRemainQuota', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005917')}
        );
      }
      return [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'orderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: baseCheckBoxList
        }
      ];
    },
    // 交易类型
    transactionTypeList() {
      const ENUM_KEY = 'YmsMerchantPropertyLogOperationTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsMerchantPropertyLogOperationTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      await this.obtainCreditLimitConfiguration();
      this.setDefaultTimerParams('three_months');
      this.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.expensesTime = [];
      v.resetDate();
      v.changeInput(1);
      v.setDefaultTimerParams('three_months');
      v.getList();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.handleColumns();
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsDistributePackageCost_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributePackageCost_queryMerchantPropertyLog, v.handleParameter()).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.$nextTick(() => {
                v.tableLoading = false;
              });
              v.total = data.total;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取费用产生时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createStartTime = null;
          v.pageParams.createEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.expensesTime = v.defaultTimePeriod(value, false);
          v.pageParams.createStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置交易时间
    resetDate() {
      this.pageParams.createStartTime = null;
      this.pageParams.createEndTime = null;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      let keyList = ['operationType'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      return params;
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsMerchantPropertyLogIds = v.selectTableData.map(i => i.ymsMerchantPropertyLogId);
      } else {
        query.ymsMerchantPropertyLogIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsDistributePackageCost_batchExportPropertyLog, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 处理列表字段
    handleColumns() {
      this.tableColumns = [];
      let hideKeyList = [];
      if (this.creditLimitConfiguration) {
        this.tableColumns = this.originalColumns;
      } else {
        hideKeyList = ['curDistributorRemainQuota', 'originalDistributorRemainQuota'];
        this.tableColumns = this.originalColumns.filter((item) => {
          return !hideKeyList.includes(item.key);
        })
      }
    },
    // 获取信用额度配置
    obtainCreditLimitConfiguration() {
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsMerchantProperty_api_queryByYmsDistributorMerchantId + this.userInfo.merchantId).then(response => {
          if (response.data.code === 0) {
            let obj = response.data.datas;
            if (obj) {
              this.creditLimitConfiguration = obj.isSettingQuota;
            }
            resolve(true)
          }
        });
      });
    },
    // 获取备注内容
    getExpenseDetailsRemarks(remarkJson) {
      const REMARK_TYPE_MAP = {
        1: ({message}) => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001072')}${message || ''}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005900')}`,
        2: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005901')}`,
        3: ({hour = 0, minute = 0, fee = '-', currency = ''}) =>
          `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005902')} ${hour}h ${minute}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005903')} ${fee} ${currency}`,
        4: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003951')}`,
        5: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003953')}`,
        6: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003952')}`,
        7: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005904')}`,
        8: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005905')}`,
        9: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005906')}`,
        10: () => `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005907')}`,
      };
      if (!remarkJson) return '';
      try {
        const {type, message, ...rest} = JSON.parse(remarkJson) || {};
        let extra = {};
        if (message) {
          try {
            const parsed = JSON.parse(message);
            if (parsed && typeof parsed === 'object') {
              extra = {...parsed, fee: parsed.price ?? parsed.fee};
            } else {
              extra.message = message;
            }
          } catch {
            extra.message = message;
          }
        }
        return REMARK_TYPE_MAP[type]?.({...rest, ...extra}) || remarkJson;
      } catch {
        return remarkJson;
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    dropDownFilter,
    exportFieldsModal
  }
};
</script>

<style>
.table-box {
  background-color: #ffffff;
  padding: 10px;
}
</style>